export const reportType = [
    {value:"unit",name:'Unit Consumed - Day Wise'},
    {value:"unit",name:'Unit Consumed - Aggregrate'},
    {value:'temp',name:'Temperature'},
    {value:'logs',name:'Equipment Logs'},
    {value:'saving',name:'Savings'},
    {value:'kvah',name:'Property Meter Reading'},
    {value:'hourlyUnits',name:'Hourly Units Data'},
    {value:'doorAnalyze',name:'Door Analyze'},
    {value:'systemOnTime',name:'System OnTime'},
    {value:'dgMixerRatio',name:'DG Mixer Ratio'},
    {value:'IncidentReport',name:'Incident Report'},
    {value:'Energy&DG',name:'Energy & DG'},
    {value:'kwhUnitLogs',name:'Kwh Unit Logs'},
    {value:'device-wise-daily',name:'Device Wise Daily Consumed Unit'},
]
export const reportPosition = {
    unit:0,
    unitAggregrate:1,
    temp:2,
    logs:3,
    saving:4,
    kvah:5,
    hourlyUnits:6,
    doorAnalyze:7,
    systemOnTime:8,
    dgMixerRatio:9,
    doorAnalyzeComplete:10,
    plantEnergy:11,
    kwhUnitLogs:12,
    deviceWiseDaily:13
}

export const notShowSavingReportByHouseName = ['Dunkin Donuts']